import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MobxAngularModule } from 'mobx-angular';
import { TooltipModule } from 'ng2-tooltip-directive';
import { OnboardingCarouselComponent } from './onboarding-carousel/onboarding-carousel.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ComponentsModule } from '../components.module';
import { ChannelModule } from '../channel/channel.module';
import { AccountModule } from '../account/account.module';
import { SharedComponentsModule as PSharedCompMod } from 'netsocial-posting/src/app/components/shared-components/shared-components.module';
import { TourStatusComponent } from './tour-status/tour-status.component';
import { ComponentsModule as LibSharedComponentsModule } from 'netsocial-lib/src/app/components/components.module';
import { TourIntroComponent } from './tour-intro/tour-intro.component';
import { UiPhoneInputModule } from 'ui-phone-input';

const components = [OnboardingCarouselComponent, TourStatusComponent, TourIntroComponent];

@NgModule({
  declarations: [...components],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    TooltipModule,
    MobxAngularModule,
    SharedComponentsModule,
    ComponentsModule,
    ChannelModule,
    AccountModule,
    PSharedCompMod,
    LibSharedComponentsModule,
    UiPhoneInputModule,
  ],
  exports: [...components],
})
export class OnboardingModule {}
